import { all, fork } from 'redux-saga/effects';
import { adminCompaniesSagas } from 'unit-admin/sagas/companies';
import { peopleSagas } from 'unit-people/saga';
import { accountSagas } from '../units/account/sagas';
import { paymentSagas } from '../units/subscription/sagas/payment';
import { subscriptionSagas } from '../units/subscription/sagas/subscription';
import * as Common from './common';

function* saga(): any {
  yield all([
    fork(Common.commonSagas),
    fork(accountSagas),
    fork(subscriptionSagas),
    fork(paymentSagas),
    fork(peopleSagas),
    fork(adminCompaniesSagas),
  ]);
}

export default saga;
